const updatesData = [
  { time: '10分钟前', title: '某顶流男星发文疑似回应恋情传闻', tag: '热议' },
  { time: '28分钟前', title: '热门网剧女主被爆片场耍大牌', tag: '新瓜' },
  { time: '1小时前', title: '知名音乐人涉嫌抄袭被原创者实锤', tag: '跟进' },
  { time: '2小时前', title: '某综艺录制现场发生意外事故', tag: '突发' },
  { time: '3小时前', title: '带货主播翻车后连夜删除直播回放', tag: '热议' },
  { time: '5小时前', title: '某女团成员社交账号被盗发布不当内容', tag: '澄清' },
  { time: '7小时前', title: '热门电影票房造假疑云再起', tag: '深度' },
  { time: '9小时前', title: '年度吃瓜人物TOP10票选结果出炉', tag: '盘点' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-8 h-8 rounded-lg bg-accent-500 flex items-center justify-center">
            <i className="ri-flashlight-line text-background-50 text-lg"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">最新快讯</h2>
        </div>
        <p className="text-foreground-500 text-sm mb-8 md:mb-10">第一时间为你推送51吃瓜、91吃瓜最新动态，吃瓜快人一步</p>

        <div className="relative pl-8 border-l-2 border-primary-200">
          {updatesData.map((item, i) => (
            <a
              key={i}
              href="#updates"
              onClick={(e) => e.preventDefault()}
              className="relative block pb-7 last:pb-0 cursor-pointer group"
            >
              <div className="absolute -left-[33px] top-0.5 w-4 h-4 rounded-full bg-primary-500 border-2 border-background-100 group-hover:scale-125 transition-transform"></div>
              <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                <span className="text-xs text-foreground-400 shrink-0 w-[72px]">{item.time}</span>
                <span className="text-sm text-foreground-800 group-hover:text-primary-600 transition-colors font-medium flex-1">
                  {item.title}
                </span>
                <span className="text-[10px] font-bold text-secondary-600 bg-secondary-50 px-2 py-0.5 rounded shrink-0 self-start sm:self-auto">
                  {item.tag}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}